<template>
    <div class="repeater">
        <slot />

        <repeater-item v-for="(clone, index) in clones" :key="index">
            <slot name="item-template" />
        </repeater-item>

        <div class="actions">
            <button class="btn medium grey" @click.prevent="clones += 1" v-text="addButtonLabelText"></button>
        </div>
    </div>
</template>

<script>
    import RepeaterItem from './RepeaterItem';

    export default {
        name: 'Repeater',
        props: ['addButtonLabel'],

        components: { RepeaterItem },

        computed: {
            addButtonLabelText(){
                return this.addButtonLabel || this.$c__('repeater item', 'Add another');
            }
        },

        data: () => (
            {
                clones: 0
            }
        )
    }

</script>
